import React, {Component} from "react";
import  {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    Image,
    KeyboardAvoidingView, Alert, Keyboard,
} from "react-native";

const {width: SCREEN_WIDTH} = Dimensions.get("window");

import HMTextView from "../../../customviews/HMTextView";
import {moderateScale} from "../../../tools/Scaling";
import Colors, {colorDark, colorPrimary} from "../../../tools/Colors";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";

import i18n from "../../../I18n/i18n";


let container = null;

export default class PrivacyScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        this.state = {

            modalHeight: 0,
            Privacy: `حفظ حریم خصوصی\n` +
                `\n` +
                `به نرم افزار "${i18n.t('appName')}"  خوش آمدید! سپاس از شما برای استفاده از این اَپلیکیشن! ما اهمیت زیادی برای حفاظت از اطلاعات شخصی شما قائل هستیم و برای همین در اینجا در مورد نوع و دامنه جمع آوری، پردازش و استفاده از اطلاعات شخصی شما در ارتباط با استفاده از آن‌ها در این سایت می‌خواهیم برای شما اطلاع رسانی کنیم.\n` +
                `\n` +
                ` \n` +
                `اطلاعات شخصی شما محرمانه تلقی می‌شود و مطابق با مقررات حفاظت از داده‌ها بر اساس سیاست حفاظت از حریم خصوصی، نگهداری می‌شود. ما آن‌ها را نه منتشر خواهیم کرد و نه در اختیار دیگر مراجع خواهیم گذاشت.\n` +
                `\n` +
                ` \n` +
                `ما هشدار می‌دهیم که انتقال داده‌ها بر روی اینترنت (به عنوان مثال در هنگام برقراری ارتباط از طریق پست الکترونیکی) ممکن است شکاف‌های امنیتی داشته باشد. حفاظت کامل از اطلاعات در مقابل دسترسی‌های اشخاص ثالث امکان پذیر نیست.\n` +
                `\n` +
                ` \n` +
                `اطلاعات منتشر شده و ارتباطی که در صفحات منتشر می‌شود ممکن است توسط اشخاص ثالث برای ارسال اطلاعات ناخواسته و تبلیغاتی مورد (سوء) استفاده واقع شود در چنین حالتی ما اقدام برای طرح دعوای حقوقی علیه سوء استفاده کنندگان را برای خود محفوظ می‌دانیم.\n` +
                `\n` +
                ` \n` +
                `۱. اطلاعات جمع آوری شده توسط ما\n` +
                `\n` +
                `برخی از خدمات ما را شما می‌توانید حتی بدون ثبت نام در اَپلیکیشن به راحتی قابل استفاده نیست. با این حال، برای استفاده از همه ویژگی‌های اَپلیکیشن، شما می‌توانید ثبت نام نماییدد.\n` +
                `\n` +
                ` \n` +
                `اطلاعات زیر در رجیستری کاربران همیشه و به طور کامل برای دیگر کاربران ثبت نام شده قابل مشاهده نیست:\n` +
                `\n` +
                ` \n` +
                `نام کاربری\n` +
                `\n` +
                `تاریخ ثبت نام در اَپلیکیشن\n` +
                `\n` +
                `تاریخ و زمان آخرین ورود به اَپلیکیشن\n` +
                `\n` +
                `احتمالا همچنین برخی اطلاعات دیگر که در مورد شما ذخیره شده است، به عنوان مثال، اگر شما داده‌های اضافی در مشخصات شخصی خودتان اضافه کرده باشید و یا اگر شما با مدیریت اَپلیکیشن ارتباط برقرار کرده باشید. توجه داشته باشید که این اطلاعات غیر اجباری است.\n` +
                `\n` +
                ` \n` +
                `۲. ورود اطلاعات\n` +
                `\n` +
                `در هر زمانی که شما به اَپلیکیشن ما مراجعه کنید در این پروسه روی سرور ما اطلاعاتی (مانند نوع مرورگر، تاریخ و زمان تماس) از سیستم شما جمع آوری می‌شود. در این پروسه داده‌های شخصی آنالیز نمی‌شوند. بنابراین، ما قادر به ثبت اطلاعات یک فرد خاص نیستیم.\n` +
                `\n` +
                ` \n` +
                `همه این اطلاعات را ما صرفا برای اهداف آماری و برای تشخیص لینک‌های معیوب یا خطاهای سرور استفاده می‌کنیم. افشای اطلاعات به اشخاص ثالث اتفاق نخواهد افتاد.\n` +
                `\n` +
                ` \n` +
                `\n` +
                `۳.روش پرداخت\n` +
                `\n` +
                `در هنگام ارسال به بانک کد پیگیری به مشتری اعلام می شود که مشتری در صورت مشکل به صورت تلفنی به شماره ۱۵۴۷ تماس گرفته یا از طریق سامانه پشتیبانی داخل اپلیکیشن مشکل خود را اعام می کند و سرویس های فروشی در این اپلیکیشن سرویس های شارژ اینترنتی هستند که بعد از پرداخت و تایید بانک سرویس مشترک شارژ می شود به صورت پیامکی نتیجه انجام خرید به مشترک اطلاع داده می شود \n` +
                `\n` +
                `4. دسترسی به حسابهای خدمات شخص ثالث\n` +
                `\n` +
                `این سرویس ها اجازه می دهد این برنامه برای دسترسی به داده ها از حساب شما در سرویس شخص ثالث و انجام اقدامات با آن. این سرویس ها به صورت خودکار فعال نمی شوند، اما نیاز به مجوز صریح کاربر می باشد.\n` +
                `\n` +
                `5. تماس\n` +
                `\n` +
                `اعتماد کاربران برای ما مهم است. بر همین اصل شرکت ساتیا آماده پاسخگویی به سوالات کاربران در رابطه با پردازش داده‌های شخصی خود، در هر زمان است. اگر سوالی دارید که در این متن سیاست حفظ حریم خصوصی پاسخ داده نشده و یا اگر مایل هستید اطلاعات بیشتری در مورد هر بند این متن بدست آورید، لطفا با شماره ۱۵۴۷ تماس بگیرید.\n`+
                `\n` +
                    `6. کد ملی و شماره موبایل\n` +
                `\n` +
                `کد ملی در هنگام ثبت نام اختباری بوده فقط برای ثبت بعضی از موارد مثل هر خانه یک درخت در روز درختکاری به هر فرد فقط یک درخت با یک کد ملی تعلق بگیرد و هیچ گونه استفاده ای ندارد و شمار موبایل فقط برای واردشدن به نرم افزار صورت می گیرد.\n`


        };

    }

    componentDidMount() {

    }

    static ShowMessageBack(text) {

    }

    componentWillUnmount() {

    }


    render() {
        return (

            <View style={{flex: 1}}>
                <HMActionBarSatia
                    props={this.props} statusBarTransparent
                    text={"حریم خصوصی"}

                    //  text={i18n.t('constant.Information')}
                    // menu={!checkLogin}
                    back
                    headerVisibility more_menu
                    onBackPress={() => this.props.navigation.pop()}

                />
                <ScrollView>
                    <View style={{padding: moderateScale(6)}}>
                        <HMTextView type={"bold"} text={this.state.Privacy} style={{
                            color: Colors.black,
                            alignSelf: 'center',
                            fontSize: moderateScale(12),
                            marginEnd: moderateScale(10),
                            marginBottom: moderateScale(8),
                            marginTop: moderateScale(8),
                        }}/>
                    </View>
                </ScrollView>
            </View>

        );


    }


}


